import "./modal.js";

/**
 * @module page-builder
 */
(function () {
  "use strict";

  var SharedInfoDialog = function SharedInfoDialog() {
    var _super = new Sparkle.PageBuilder.Modal.Deprecated();
    var self = {};

    _.extend(self, _super, {
      template: "shared-info-dialog",
      initialize: function (componentId) {
        _super.initialize.apply(this, []);

        this.addPrimaryButton(
          "Done",
          function () {
            jQuery(this.dialog).find("form").trigger("submit");
            this.remove();
          }.bind(this),
        );

        // Tabs
        Sparkle.Tabs.initializeTabs(this.dialog);

        this.updatePreview(componentId);
        this.show();
      },

      updatePreview: function (componentId) {
        var $dialog = jQuery(this.dialog);

        $dialog.find("iframe").attr("src", "/components/" + componentId + "?responsive_preview=false");
        $dialog.find("#component-uses-tab").on("click", ".pagination [href], .per-page-count [href]", loadClickInModal);
        $dialog.find("#component-uses-tab").on("click", "tbody [href]", loadClickInNewTab);

        loadUsesTabContent(
          "/admin/components/" +
            componentId +
            "/documents?api=shared_info_dialog&custom_view_configuration=Title,Overrides",
        );
        loadInfoTabContent("/admin/components/" + componentId + "/edit?api=shared_info_dialog");

        function loadClickInModal(event) {
          event.preventDefault();
          loadUsesTabContent(jQuery(this).attr("href"));
        }

        function loadClickInNewTab(event) {
          jQuery(this).attr("target", "_blank");
        }

        function loadUsesTabContent(href) {
          $dialog
            .find("#component-uses-tab")
            .load(href, function () {
              $dialog.find("#component-uses-tab .per-page-count").hide();
            })
            .scrollTop(0);
        }

        function loadInfoTabContent(href) {
          $dialog.find("#component-info-tab").load(href, function () {
            $dialog.find("#component-info-tab form").attr("data-remote", true);
          });
        }

        Sparkle.PageBuilder.SharedComponent.fetch(componentId).then(function (response) {
          $dialog.find(".title").html(response.name);
        });
      },
    });

    self.initialize.apply(self, arguments);
    return self;
  };

  Sparkle.PageBuilder.SharedInfoDialog = SharedInfoDialog;
})();
